'use strict';

require('views/PreActivated/PreActivated.scss');
require('styles/_common.scss');

const React = require('react/addons'),
  {t} = require('services/i18nextWrapper'),
  Router = require('react-router'),
  apiAppUrl = process.env.URL_API,
  mui = require('material-ui'),
  {Route, RouteHandler, Link} = Router,
  {RaisedButton} = mui;

var CheckEmailResetPassword = React.createClass({displayName: "CheckEmailResetPassword",

  handlerClick: function () {
    window.location = apiAppUrl + '/#/login';
  },

  render: function () {
    return (
      React.createElement("div", {className: "preactivated-page-container jumbotron"}, 
        React.createElement("div", {className: "container text-center"}, 
          React.createElement("h1", {className: "light"}, t('confirm_new_password_static_page_title')), 
          React.createElement("p", {className: "text-left"}, t('confirm_new_password_static_page_text')), 
          React.createElement("p", {className: "text-left"}, t('confirm_new_password_static_page_greeting')), 
          React.createElement("br", null), 
          React.createElement(RaisedButton, {
            label: t('label_login'), 
            primary: true, 
            onTouchTap: this.handlerClick}
          ), 
          React.createElement("br", null), 
          React.createElement("br", null), 
          React.createElement("br", null), 
          React.createElement("img", {style: {height: '60px'}, src: "/assets/images/logo-small-dark.png"})
        )
      )
    );
  }
});

module.exports = CheckEmailResetPassword;



/** WEBPACK FOOTER **
 ** ./src/views/CheckEmailResetPassword/CheckEmailResetPassword.jsx
 **/